/* src/app/@shared/app-list-dialog/app-list-dialog.component.scss */
.cotain {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 15px;
}
.cotain p {
  min-height: 30px;
  flex-wrap: nowrap;
  margin-bottom: 16px;
  word-break: break-all !important;
}
::ng-deep .mat-dialog-container {
  border-radius: 25px !important;
  padding: 0 !important;
  background-color: #fbf9f4 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  overflow: hidden;
}
.dialog-header-work-flow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: var(--brand-sidebar) !important;
  color: #ffffff;
}
.dialog-header-work-flow .popHead-work-flow {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
}
.dialog-header-work-flow .close-icon-btn {
  width: 35px;
  height: 35px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: var(--brand-sidebar);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 1;
}
.dialog-header-work-flow .close-icon-btn:hover {
  background: #29445d;
  opacity: 1;
}
.dialog-header-work-flow .close-icon-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
}
.custom-dialog-content {
  padding: 12px 16px !important;
  max-height: 65vh;
  margin: 0 !important;
}
.cotain {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.cotain p {
  min-height: 30px;
  flex-wrap: nowrap;
  margin-bottom: 16px;
  word-break: break-all !important;
}
.info-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 10px 14px;
  border: 1px solid #e2ded5;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}
.info-card.role-card {
  border-left: 3px solid var(--brand-sidebar);
}
.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.info-row .info-label {
  font-size: 12.5px;
  color: var(--brand-header);
  font-weight: 500;
  min-width: 120px;
}
.info-row .info-value {
  font-size: 13px;
  color: #111827;
  font-weight: 600;
  text-align: right;
  word-break: break-word;
}
.info-row .info-value.name-highlight {
  color: var(--brand-sidebar);
  font-weight: 500;
}
.info-row .info-value.badge-designation {
  background: #f0f4f8;
  color: var(--brand-sidebar);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}
.custom-dialog-actions {
  padding: 8px 16px 12px 16px !important;
  margin: 0 !important;
  background: #fbf9f4;
  border-top: 1px solid #eae5d9;
}
.custom-dialog-actions .theme-close-btn {
  background-color: var(--brand-accent);
  color: #ffffff;
  border-radius: 10px;
  padding: 2px 18px;
  height: 32px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  transition: all 0.2s ease;
}
.custom-dialog-actions .theme-close-btn:hover {
  background-color: #a8832a;
}
.emp_key {
  height: auto;
  font-size: 16px;
  font-weight: bolder;
}
.emp_value {
  width: 50%;
  height: auto;
  font-size: 16px;
  font-weight: 100;
}
.emp_value p {
  font-weight: 400;
}
.dive .head_parg {
  font-weight: 600;
}
.dive .paragrap {
  border: 2px solid;
  padding: 8px;
  overflow: wrap;
  overflow-wrap: anywhere;
  border-radius: 6px;
}
